import React, {useEffect, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator, CCText,
    Modal,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';


import {useDispatch, useSelector} from 'react-redux';
import {
    BorderlessButton,
    DarkButton,
    QuantityPicker,
    ThemeButton
} from '../../../custom-packages/react-button-package/ButtonPackage';
import AppConfig from '../../../AppConfig';
import Styles from "../../../Styles";
import * as MaskFunctions from "@chocostack/maskifier";
import {GetAuthObject} from "../../../authentication/AuthFunctions";
import * as AuthActions from "../../../store/actions/authActions";
import {CheckmarkCircle} from "../../../custom-packages/icon-components/icon-components";
import ArtIcon from "../../../assets/custom-icons/ArtIcon";
import InfiniteIcon from "../../../assets/custom-icons/InfiniteIcon";
import BrandIcon from "../../../assets/custom-icons/BrandIcon";

import stripePromise from '../../../custom-packages/stripe/StripeLoader';

import {AddressElement, Elements, PaymentElement, useStripe} from "@stripe/react-stripe-js";

const TUpgradeModal = {
    // English
    "enUS": {
        RESTAURANTS: "Restaurants",
        TOTAL: "Total",
        STARTING_AT: "Starting At",
        MONTHLY: "/ Month",
        'UPGRADE_TO': 'Upgrade your plan to ',
        'UPGRADE_TO_DESC': 'Upgrade your plan and get new benefits:',
        'UPGRADE': 'UPGRADE PLAN',
        'CANCEL': 'Cancel',
        'BASIC': 'BASIC',
        'STANDARD': 'STANDARD',
        'PAY': 'PAY',
        'SEE_PLANS': 'SEE PLANS',
        'TRY_OUT_30': 'FREE 30 DAY TRIAL',
        CUSTOMIZE: "Customize Your Menu",
        CUSTOMIZE_DESC: "Give a new life to your menu and customize it as you wish.",
        BRANDING: "Use your own brand",
        BRANDING_DESC: "Upload your own logo for it to appear on your QR Codes and in your Digital Menu",
        UNLIMITED_FOOD: "Unlimited Items",
        UNLIMITED_FOOD_DESC: "Add as much items you need for your digital menu.",
        UNLIMITED_MENUS: "Unlimited Digital Menus",
        UNLIMITED_MENUS_DESC: "Unlimited digital menus for you to create a diverse catalog for multiple restaurants and bars!",
        IMAGE: "Images For All Your Items",
        IMAGE_DESC: "Showcase your dishes to your customers by adding an image to each food item in your menu",
        REQUEST_WAITER: "Request a Waiter",
        REQUEST_WAITER_DESC: "Your customers can request a waiter in real time from your digital menu in your restaurant.",
        REQUEST_WAITER_MAX_RESTAURANTS_DESC: "If you operate in more than one location, you can enable this feature in the additional restaurants for $3.99 USD per month each.",
        UPGRADE_SUCCESSFUL: "Your plan has been upgraded, you can close this window now.",
        CLOSE: "Close",
        TRIAL_MESSAGE: "If your subscription is in its trial period, you will not be charged until the trial ends.",
    },
    // Spanish
    "esMX": {
        RESTAURANTS: "Restaurantes",
        TOTAL: "Total",
        STARTING_AT: "Desde",
        MONTHLY: "/ Mes",
        'UPGRADE_TO': 'Mejora tu plan a ',
        'UPGRADE_TO_DESC': 'Mejora tu plan y obtén los siguientes beneficios:',
        'UPGRADE': 'MEJORAR PLAN',
        'CANCEL': 'Cancelar',
        'BASIC': 'BÁSICO',
        'STANDARD': 'STANDARD',
        'PAY': 'PAGAR',
        'SEE_PLANS': 'VER PLANES',
        'TRY_OUT_30': 'PROBAR POR 30 DÍAS GRATIS',
        CUSTOMIZE: "Personaliza tu Menú",
        CUSTOMIZE_DESC: "Da nueva vida a tu menú personalizando su apariencia a tu gusto. ¡Muestra tus alimentos de una manera única!",
        BRANDING: "Utiliza tu propia marca",
        BRANDING_DESC: "Sube tu propio logotipo para que aparezca en tus códigos QR y en tu menú digital",
        UNLIMITED_FOOD: "Alimentos Ilimitados",
        UNLIMITED_FOOD_DESC: "Agrega cuantos alimentos necesites para tu menú digital. ¡No limites el paladar de tus clientes!",
        UNLIMITED_MENUS: "Menús Digitales Ilimitados",
        UNLIMITED_MENUS_DESC: "Crea y administra todos los menús digitales que necesites para crear un catálogo diverso para diferentes restaurantes y bares!",
        IMAGE: "Imágenes para Todos tus Alimentos",
        IMAGE_DESC: "Agrega imágenes para previsualizar tus alimentos. 1 imagen por alimento. Para todos tus alimentos.",
        REQUEST_WAITER: "Solicitar un Mesero",
        REQUEST_WAITER_DESC: "Tus clientes pueden solicitar un mesero en tiempo real desde tu menú digital en tu restaurante.",
        REQUEST_WAITER_MAX_RESTAURANTS_DESC: "Si operas en más de una ubicación, puedes activar esta función en los restaurantes adicionales por $59 MXN / Mes adicionales por cada uno.",
        UPGRADE_SUCCESSFUL: "Tu plan ha sido mejorado, ya puedes cerrar esta ventana.",
        CLOSE: "Cerrar",
        TRIAL_MESSAGE: "Si tu suscripción está en su periodo de prueba, no se realizará el cargo hasta que el periodo de prueba termine.",
    }
}

const UpgradeModal = (props) => {
    return <Elements stripe={stripePromise}>
        <ModalContent />
    </Elements>;
}

export default UpgradeModal;

const ModalContent = (props) => {
    const auth = useSelector(state => state.Auth);
    const dispatch = useDispatch();
    const stripe = useStripe();

    const [validated, setValidated] = useState(false);
    const [retrying, setRetrying] = useState(false);
    const [upgrading, setUpgrading] = useState(false);
    const [loading, setLoading] = useState(true);
    const [pricing, setPricing] = useState(null);
    const [priceID, setPriceID] = useState(null);
    const [checkout, setCheckout] = useState(false);
    const [quantity, setQuantity] = useState(1);

    const [creatingCheckout, setCreatingCheckout] = useState(false);

    const gtag_report_conversion = (url) => {
        var callback = function () {
            if (typeof(url) !== 'undefined') {
                window.location = url;
            }
        };

        window.gtag('event', 'conversion', {
            'send_to': 'AW-850564176/pBhFCOCuudQYENCoypUD',
            'event_callback': callback
        });

        return false;
    }

    const createCheckoutSession = async (id) => {
        if(auth.sub)
            return;

        gtag_report_conversion()

        setCreatingCheckout(true)
        const formData = new FormData();

        formData.append('price_id', id);

        const response = await fetch(AppConfig.URL + '/Subscription/CheckoutSession/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': auth.token
                },
                body: new URLSearchParams(formData)
            }
        );

        if (response.ok) {
            const json = await response.json();
            const sessionId = json.sessionId;

            await stripe.redirectToCheckout({sessionId: sessionId});
            setCreatingCheckout(false)
        } else {
            console.error('Error:', response.statusText);
        }
    }


    useEffect(() => {
        if (!props.visible)
            return

        const f = async () => {
            const fetchPricing = async (code) => {
                const response = await fetch(AppConfig.URL + '/Subscription/FetchPricing/?SubscriptionCode=' + code, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': auth.token
                        },
                    }
                );

                let data = await response.json();

                return data;
            }

            const standardPricingData = await fetchPricing(props.plan);

            if (standardPricingData.success) {
                setPriceID(standardPricingData.priceID);
                setPricing(standardPricingData.pricing);

                setLoading(false)
            }
        }

        f()
    }, [props.visible])

    return (
        <Modal
            visible={props.visible}
            onRequestClose={props.onRequestClose}
            hideHeader={true}
            footer={validated ? null : <View
                style={{flexDirection: 'row', justifyContent: 'flex-end'}}
            >
                {
                    upgrading || creatingCheckout ?
                        null
                        :
                        <BorderlessButton
                            textStyle={{fontSize: 17}}
                            text={TUpgradeModal[AppConfig.lang].CANCEL}
                            onPress={() => {
                                props.onRequestClose()
                            }}
                        />
                }
                <View style={{width: 7}}></View>
                {
                    !auth.sub ?
                        <ThemeButton
                            disabled={creatingCheckout}
                            text={
                                creatingCheckout ?
                                    <ActivityIndicator color={'white'} size={25} />
                                    :
                                    TUpgradeModal[AppConfig.lang].TRY_OUT_30
                            }
                            onPress={() => {
                                createCheckoutSession(priceID)
                            }}
                        />
                        :
                        checkout ?
                            <ThemeButton
                                disabled={upgrading}
                                text={upgrading ? <ActivityIndicator style={{alignSelf: 'center'}} size="20"
                                                                     color="#FFF"/> : TUpgradeModal[AppConfig.lang].PAY}
                                onPress={async () => {
                                    setUpgrading(true)

                                    const response = await fetch(AppConfig.URL + '/Subscription/ChangePlan/?priceID=' + priceID + '&quantity=' + quantity, {
                                            method: 'GET',
                                            headers: {
                                                'Content-Type': 'application/x-www-form-urlencoded',
                                                'Authorization': auth.token
                                            },
                                        }
                                    );

                                    let data = await response.json();

                                    if (data.success) {
                                        setTimeout(async () => {
                                            const response = await fetch(AppConfig.URL + '/Subscription/FetchSubscription', {
                                                    method: 'GET',
                                                    headers: {
                                                        'Accept': 'application/json',
                                                        'Content-Type': 'application/json',
                                                        'Authorization': auth.token
                                                    },
                                                }
                                            );

                                            let data = await response.json();

                                            if (data.success) {
                                                const subData = {
                                                    subscription: data.subscription
                                                }
                                                const newAuth = GetAuthObject(subData);

                                                dispatch(AuthActions.saveAuth(newAuth))
                                            } else {
                                                console.log('NOT SUCCESSFUL UPGRADE')
                                            }

                                            setValidated(data.success)
                                            setUpgrading(false)
                                        }, 1500)
                                    }
                                }}
                            />
                            :
                            <ThemeButton
                                disabled={loading}
                                text={TUpgradeModal[AppConfig.lang].UPGRADE}
                                onPress={() => {
                                    setCheckout(true)
                                }}
                            />
                }
            </View>}
        >
            <View>
                <div style={{
                    ...Styles.themeColor
                }}>
                    <div style={{textAlign: 'center'}}>
                        <h1>
                            {TUpgradeModal[AppConfig.lang].UPGRADE_TO + ' ' + TUpgradeModal[AppConfig.lang][props.plan]}
                        </h1>
                    </div>
                </div>
                {
                    validated ?
                        <View
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            <CheckmarkCircle/>
                            <div className={'alert alert-info'} style={{margin: 15, textAlign: 'center'}}>
                                {TUpgradeModal[AppConfig.lang].UPGRADE_SUCCESSFUL}
                            </div>
                            <ThemeButton
                                text={TUpgradeModal[AppConfig.lang].CLOSE}
                                onPress={props.onRequestClose}
                            />
                        </View>
                        :
                        checkout ?
                            <View>
                                <View style={{flexDirection: 'row', justifyContent: 'space-between', padding: 15}}>
                                    <View style={{alignItems: 'flex-start'}}>
                                        <strong>
                                            {TUpgradeModal[AppConfig.lang].RESTAURANTS}
                                        </strong>
                                        <QuantityPicker
                                            quantity={quantity}
                                            onChange={(newValue) => {
                                                setQuantity(newValue)
                                            }}
                                        />
                                    </View>
                                    <View style={{alignItems: 'flex-end'}}>
                                        <strong>
                                            {TUpgradeModal[AppConfig.lang].TOTAL}
                                        </strong>
                                        <div style={{fontWeight: 'bold', ...Styles.themeSecondaryColor}}>
                                            {
                                                MaskFunctions.maskMoney(pricing.spR_PRICE + ((quantity - 1) * pricing.spR_PRICE_INCREMENT))
                                                + ' '
                                                + pricing.spR_CURRENCY
                                                + ' ' + TUpgradeModal[AppConfig.lang].MONTHLY
                                            }
                                        </div>
                                    </View>
                                </View>
                            </View>
                            :
                            <div>
                                <div
                                    style={{
                                        marginTop: 15,
                                        marginBottom: 15
                                    }}
                                >
                                    {loading ?
                                        <div>
                                            <ActivityIndicator size={25}/>
                                        </div>
                                        :
                                        <div style={{textAlign: 'center', ...Styles.themeSecondaryColor}}>
                                            <strong
                                                style={{
                                                    fontSize: '1.5rem'
                                                }}
                                            >
                                                {
                                                    props.plan === AppConfig.SUB_STANDARD ?
                                                        TUpgradeModal[AppConfig.lang].STARTING_AT + ' '
                                                        :
                                                        null
                                                }
                                                {MaskFunctions.maskMoney(pricing.spR_PRICE)}
                                                {' '}
                                                {pricing.spR_CURRENCY}
                                                {' ' + TUpgradeModal[AppConfig.lang].MONTHLY}
                                            </strong>
                                        </div>
                                    }
                                </div>
                                <div className={'alert alert-info'}>
                                    {TUpgradeModal[AppConfig.lang].UPGRADE_TO_DESC}
                                </div>
                                {
                                    props.plan === AppConfig.SUB_BASIC ?
                                        <BasicData/>
                                        :
                                        null
                                }
                                {
                                    props.plan === AppConfig.SUB_STANDARD ?
                                        <StandardData/>
                                        :
                                        null
                                }
                            </div>
                }
            </View>
        </Modal>
    );
}

const StandardData = (props) => {

    return <View>
        <View>
            <strong style={{display: "flex", flexDirection: 'row', alignItems: 'center', ...Styles.themeColor}}>
                {TUpgradeModal[AppConfig.lang].REQUEST_WAITER}
            </strong>
            <div style={{color: '#555555'}}>
                {TUpgradeModal[AppConfig.lang].REQUEST_WAITER_DESC}
                <br/>
                <br/>
                {TUpgradeModal[AppConfig.lang].REQUEST_WAITER_MAX_RESTAURANTS_DESC}
            </div>
            <br/>
            <strong style={{display: "flex", flexDirection: 'row', alignItems: 'center', ...Styles.themeColor}}>
                {TUpgradeModal[AppConfig.lang].UNLIMITED_MENUS}
            </strong>
            <div style={{color: '#555555'}}>
                {TUpgradeModal[AppConfig.lang].UNLIMITED_MENUS_DESC}
            </div>
        </View>
    </View>
}

const BasicData = (props) => {

    return <View>
        <View>
            <View style={{flexDirection: 'row'}}>
                <ArtIcon size={25} color={Styles.themeColor.color}/>
                <strong style={{marginLeft: 5, display: "flex", flexDirection: 'row', alignItems: 'center', ...Styles.themeColor}}>
                    {TUpgradeModal[AppConfig.lang].CUSTOMIZE}
                </strong>
            </View>
            <div style={{color: '#555555', fontSize: 17}}>
                {TUpgradeModal[AppConfig.lang].CUSTOMIZE_DESC}
            </div>
            <br/>
            <View style={{flexDirection: 'row'}}>
                <BrandIcon size={25} color={Styles.themeColor.color} />
                <strong style={{marginLeft: 5, display: "flex", flexDirection: 'row', alignItems: 'center', ...Styles.themeColor}}>
                    {TUpgradeModal[AppConfig.lang].BRANDING}
                </strong>
            </View>
            <div style={{color: '#555555', fontSize: 17}}>
                {TUpgradeModal[AppConfig.lang].BRANDING_DESC}
            </div>
            <br/>
            <View style={{flexDirection: 'row'}}>
                <InfiniteIcon size={25} color={Styles.themeColor.color} style={{ marginTop: 7 }}/>
                <strong style={{marginLeft: 5,display: "flex", flexDirection: 'row', alignItems: 'center', ...Styles.themeColor}}>
                    {TUpgradeModal[AppConfig.lang].UNLIMITED_FOOD}
                </strong>
            </View>
            <div style={{color: '#555555', fontSize: 17}}>
                {TUpgradeModal[AppConfig.lang].UNLIMITED_FOOD_DESC}
            </div>
            <br/>
        </View>
    </View>
}